import InputLabel from '@mui/material/InputLabel'
import Grid from '@mui/material/Grid2'
import React from 'react'

/** @notExported   */
interface CaleoInputLabelProps {
  /** Label element id. */
  id?: string
  /** HTML for attribute. */
  htmlFor?: string
  /** label text. */
  label?: React.ReactNode
  /** whether the input is required. */
  required?: boolean
  /** icon. */
  icon?: React.ReactElement
}

/**
 * Caleo input label.
 *
 * @returns Caleo input label component.
 * @notExported
 */
const CaleoInputLabel: React.FC<CaleoInputLabelProps> = ({ id, htmlFor, label, required = false, icon }) => {
  return (
    <Grid container alignItems="center">
      <Grid sx={{ color: theme => theme.palette.primary.main, marginRight: '5px' }}>{icon}</Grid>
      <Grid>
        <InputLabel
          id={id}
          sx={{
            fontWeight: 'bold',
            letterSpacing: '0px',
            color: theme => theme.palette.primary.main,
            fontSize: '15px',
            fontFamily: 'Helvetica',
            '&::first-letter': {
              textTransform: 'capitalize',
            },
          }}
          required={required}
          htmlFor={htmlFor}
        >
          {label}
        </InputLabel>
      </Grid>
    </Grid>
  )
}

export default CaleoInputLabel
